import { useState, type ReactElement } from 'react';
import { Box, useTranslation } from '@common';
import * as Base from '@base';
import { service } from '../service';
import styles from '../style.module.less';
import { DragItem, Highlighter } from '../../component';
import { usePrimaryColor } from '../../hooks';
import { Character } from './character';
import type { ShotEyesStarProps } from './types';

export function ShotEyesStarDesignMode(props: ShotEyesStarProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();
  const [value, setValue] = useState<number>(0);
  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesStar')} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={styles.input}>
        <Base.Rate
          count={props.option?.length ?? 5}
          value={value}
          character={rate => (
            <Character
              index={rate.index}
              selectStyle={props.selectStyle}
              option={props.option}
              value={value}
            />
          )}
          onChange={data => setValue(data)}
        />
      </Box>
    </Box>
  );
}
